<template>
  <div>
    <!-- 头图 -->
    <div class="bg_pic">
      <img src="https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/171807366340638.jpg" alt="" />
    </div>
    <div class="container">
      <div class="item">
        <div class="item_title_box">
          <span class="item_title">总公司:</span>
        </div>
        <span style="color: #2e6ab0">Spectrum Brands 品谱集团</span>
      </div>
      <div class="item">
        <div class="item_title_box">
          <span class="item_title">总公司网址:</span>
        </div>
        <a href="https://www.spectrumbrands.com/" target="_blank">https://www.spectrumbrands.com/</a>
      </div>
      <div class="item">
        <div class="item_title_box">
          <span class="item_title">中国分公司地址:</span>
        </div>
        <span>广东省深圳市南山区桃园路1号西海明珠大F栋23层</span>
      </div>
      <div class="item_new">
        <div class="item_title_box">
          <span class="item_title">联系电话:</span>
        </div>
        <div class="item_content">
          <span>0755-29833111</span>
          <span>400-998-1843</span>
        </div>
      </div>
      <div class="item_new">
        <div class="item_title_box">
          <span class="item_title">品牌总代理:</span>
        </div>
        <div class="item_content">
          <span>德彩中国大陆总代理：聚流水族 </span>
          <span>Instant Ocean 中国大陆独家总代理：聚流水族 </span>
        </div>
      </div>
      <div class="item_new">
        <div class="item_title_box">
          <span class="item_title">聚流水族联系电话:</span>
        </div>
        <div class="item_content">
          <span>业务热线：181 2783 0282 </span>
          <span>总经理热线：138 2226 0920 </span>
        </div>
      </div>
      <div class="item_new">
        <div class="item_title_box">
          <span class="item_title">市场合作:</span>
        </div>
        <div class="item_content">
          <span>Demi.Cui@spectrumbrands.com</span>
        </div>
      </div>
      <div class="item_new">
        <div class="item_title_box">
          <span class="item_title">验证相关:</span>
        </div>
        <div class="item_content">
          <span>zoe.liang@spectrumbrands.com</span>
        </div>
      </div>
    </div>
    <!-- 底部栏 -->
    <foot></foot>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss">
.bg_pic {
  width: 100%;

  img {
    width: 100%;
    vertical-align: middle;
  }
}

.container {
  width: 1000px;
  margin: 40px auto 90px;

  .item {
    height: 80px;
    padding: 10px 0;
    border-bottom: 1px solid #e8e8e8;
    box-sizing: border-box;
    display: flex;
    flex-wrap: nowrap;

    .item_title_box {
      width: 300px;
      text-align: right;
      margin-right: 90px;

      .item_title {
        color: #666;
        font-size: 20px;
        letter-spacing: 1.5px;
        font-weight: normal;
      }
    }

    span {
      color: #333;
      font-size: 24px;
      font-weight: 600;
      line-height: 80px;
      letter-spacing: 1.5px;
    }

    a {
      text-decoration: none;
      color: #333;
      font-size: 24px;
      font-weight: 600;
      line-height: 80px;
      letter-spacing: 1.5px;
    }
  }
}

.item_new {
  height: 160px;
  padding: 10px 0;
  border-bottom: 1px solid #e8e8e8;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;

  .item_title_box {
    width: 300px;
    text-align: right;
    margin-right: 90px;

    .item_title {
      color: #666;
      font-size: 20px;
      letter-spacing: 1.5px;
      font-weight: normal;
    }
  }

  .item_content {
    display: flex;
    flex-direction: column;

    span {
    color: #333;
    font-size: 24px;
    font-weight: 600;
    line-height: 45px;
    letter-spacing: 1.5px;
  }
  }

  span {
    color: #333;
    font-size: 24px;
    font-weight: 600;
    line-height: 60px;
    letter-spacing: 1.5px;
  }
}
</style>